/* eslint-disable no-useless-escape */
import { ReactComponent as PDFIcon } from '../resources/icons/Pdf_File_Icon.svg'
import { ReactComponent as TextIcon } from '../resources/icons/Text_File_Icon.svg'
import { ReactComponent as DocIcon } from '../resources/icons/Doc_File_Icon.svg'
import { ReactComponent as PngIcon } from '../resources/icons/Png_File_Icon.svg'
import { ReactComponent as PptIcon } from '../resources/icons/Ppt_File_Icon.svg'

export const IsGoogleRecaptchaEnabled =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLED === 'true'

export const genderOptions = [
  { id: 1, name: 'Male' },
  { id: 2, name: 'Female' },
  { id: 3, name: 'Non-binary' },
  { id: 4, name: 'Genderqueer' },
  { id: 5, name: 'Transgender Man' },
  { id: 6, name: 'Transgender Woman' },
  { id: 7, name: 'Other' },
]

export const SubscriptionTypes = {
  FREE: 'Free',
  BASIC_PACKAGE: 'Basic Package',
  PREMIUM_PACKAGE: 'Premium Package',
  ANNUAL_PREMIUM_PACKAGE: 'Annual Premium Package',
  INDIVIDUAL_PITCHES: 'Individual Pitches',
}

export const NODE_ENV = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
}

export const UserVerificationStatus = {
  PENDING: 'pending',
  ACCEPT: 'accept',
  REJECT: 'reject',
}

export const MessageTypes = {
  TEXT: 'text',
  IMAGE: 'images',
  VIDEO: 'video',
  AUDIO: 'audio',
  DOCUMENT: 'document',
}

export const integerRegExp = /^\d+$/

export const floatRegExp = /^(\d*\.{0,1}\d{0,2}$)/

export const textRegExp = /^(?!(?:[^0-9]*[0-9]){4})[A-Za-z0-9\s.,'"(){}[\]]*$/i
// export const skillsRegExp =
//   /^(?:[A-Za-z._., '"(){}[\]\s]*[0-9]){0,3}[A-Za-z._]*$/i

export const skillsRegExp =
  /^(?!(?:[^0-9]*[0-9]){4})[A-Za-z0-9\s.,'"(){}[\]-]*$/i

// export const nameRegExp =
//   /^(?:[A-Za-z0-9._!@#$%^&*()_+={}\[\]:;"'<>?,\/]*[0-9]){0,3}[A-Za-z0-9._!@#$%^&*()_+={}\[\]:;"'<>?,\/]*$/

// export const usernameRefExp =
//   /^(?:[A-Za-z0-9._!@#$%^&*()_+={}\[\]:;"'<>?,\/]*[0-9]){0,3}[A-Za-z0-9._!@#$%^&*()_+={}\[\]:;"'<>?,\/]*$/

export const nameRegExp = /^(?!(?:[^0-9]*[0-9]){4})[A-Za-z0-9 ]*$/i

export const otherProfessionRegExp = /^(?!(?:[^0-9]*[0-9]){4})[A-Za-z0-9 ]*$/i

export const usernameRefExp = /^(?:[A-Za-z._]*[0-9]){0,3}[A-Za-z._]*$/

const TEXT_ALLOWED_CHAR = /^[A-Za-z0-9\s.,'"(){}\[\]]$/i
const SKILLS_ALLOWED_CHAR = /^[A-Za-z0-9\s.,'"(){}[\]-]$/i
const OTHER_PROFESSION_ALLOWED_CHAR = /^[A-Za-z0-9 ]$/i
const NAME_ALLOWED_CHAR = /^[A-Za-z0-9 ]$/i
const USERNAME_ALLOWED_CHAR = /^[A-Za-z._0-9]$/i

export const limitToFirstThreeDigits = (value = '') => {
  let digitCount = 0
  return [...value]
    .filter((char) => {
      if (/\d/.test(char)) {
        digitCount += 1
        return digitCount <= 3
      }
      return true
    })
    .join('')
}

const filterAllowedChars = (value, charPattern) =>
  [...(value ?? '')].filter((char) => charPattern.test(char)).join('')

export const sanitizeTextFieldInput = (
  value,
  { type = 'text', maxLength } = {},
) => {
  const charPatterns = {
    text: TEXT_ALLOWED_CHAR,
    skills: SKILLS_ALLOWED_CHAR,
    otherProfession: OTHER_PROFESSION_ALLOWED_CHAR,
    name: NAME_ALLOWED_CHAR,
    username: USERNAME_ALLOWED_CHAR,
  }

  let sanitized = filterAllowedChars(
    value,
    charPatterns[type] || charPatterns.text,
  )
  sanitized = limitToFirstThreeDigits(sanitized)

  if (maxLength != null) {
    sanitized = sanitized.slice(0, maxLength)
  }

  return sanitized
}

export const urlRegExp =
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi

export const tooltipContent = {
  editProfile: [
    'Please ensure your image does not contain text, numbers, or email addresses, as such content should not be allow to upload the image.',
    'Please ensure you upload an image with proper image format jpg, png & jpeg that meets the minimum size requirement, as larger or oversized images will not be allowed for upload.',
  ],
  username: [
    `Only alphabets and numbers are allowed in this field. No special characters except ' . ' and ' _ '.`,
    `Maximum 3 numbers are allowed.`,
    `Uppercase letter not allowed in this field.`,
  ],
  name: [
    `Only alphabets are allowed in this field.`,
    `Maximum 3 numbers are allowed.`,
  ],
  otherProfession: [
    `Only alphabets are allowed in this field.`,
    `Maximum 3 numbers are allowed.`,
  ],
  updateProfession: [
    `Update or select the professions or skills that best match your expertise. This will help you appear in searches related to the professions you choose. Click on the below professions to modify or change.`,
  ],
  text: [
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  hireTitle: [
    `Create a clear and descriptive title for your Hire Call, specifying the role you're hiring for and the project. Be specific about the type of talent or skills needed, such as 'Casting Lead Actor for Romantic Comedy Series,' 'Looking for Cinematographer for Indie Horror Film,' or 'Hiring Voice Actors for Animated Series.' This helps potential applicants understand the opportunity clearly.`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
  ],
  title: [
    `Enter the title of your hire, such as a hiring shout-out, a film title, a casting call, or a name that defines your subject, or a pitch promoting  yourself to get hired.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
  ],
  pitchName: [
    `Enter a clear and concise title for your pitch that reflects the subject or project you're presenting. This could be the title of a film, a casting call, a technician pitch, or a self-promotion pitch for roles. For example: 'Titanic – Film Pitch' for a project you're pitching, 'Prabhas – Actor Pitch' if you're promoting yourself for acting roles, or 'John Doe – Cinematographer Pitch' for a technician role. Make sure your title is specific and easy to understand for those reviewing your pitch.`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  pitchDescription: [
    `Write about the purpose or content of your pitch. What are you hoping to achieve? For example, are you looking for collaborations, talent for your project, production support, or job opportunities? Briefly describe what you're seeking, begin with 'Looking for Collaborations,' 'Seeking Acting Roles,' or 'In Need of Production Support.'`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  about: [
    `Write a brief about you and your relation with this Pitch`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  synopsis: [
    `Provide a brief overview or summary here. For actors, this could be a short description of your work, experience, and skills. For technicians, it might be a summary of your expertise or notable projects. If you're posting a project or a story, share a concise synopsis that highlights the key plot points, themes, and what makes the project unique. This section should give others a quick but insightful understanding of your work, expertise, or project.`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  onePageStory: [
    `Introduction: Briefly explain the core purpose of your project and its relevance. For films, mention the detailed narrative of your story including central themes and emotional journey.`,
    `Why This Project?: Highlight unique elements that make your project appealing. For films, describe the fresh perspective, emotional arcs, and audience resonance.`,
    `Benefits to the Audience: Explain the value your project brings—emotional connection, inspiration, or entertainment. For films, emphasize how the narrative will engage viewers.`,
    `Project Overview: Summarize your project's scope and goals. For films, include genre, setting, and the plot structure (e.g., coming-of-age, thriller, etc.).`,
    `Why This Pitch Deserves Consideration: Outline why your project stands out and its potential impact. For films, mention cinematic appeal and distribution opportunities.`,
    `Funding Allocation: Specify how funds will be used (e.g., development, production, marketing). For films, highlight script development, filming, and post-production.`,
    `Why This Pitch?: Communicate the long-term value of your project. For films, mention alignment with industry trends or genre innovation.`,
    `Additional Information: Provide details about the target audience, team, and potential collaborators. For films, include key actors, directors, or production partners.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  imageTitle: [
    `Enter title.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  videoTitle: [
    `Enter title.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  audioTitle: [
    `Enter title.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  locationName: [
    `Enter location name.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  lookAndFeelTitle: [
    `Enter title.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  characterName: [
    `Enter name.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  characterTraits: [
    `Write here.`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  castAndCrewName: [
    `Enter name.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  category: [
    `Expenses,Salaries, Shooting, Equip, Post-DI.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  phases: [
    `Pre-production, production, post-production, etc.`,
    `Only alphabets are allowed in this field.`,
    `Only " ,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  message: [
    `A brief about the content of the pitch`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  hireMessage: [
    `Use this section to provide a brief message about the opportunity, expectations, and any specific requirements for the role. This is your chance to give potential candidates a better understanding of what you're looking for and why they should apply. For example: 'We’re looking for skilled cinematographers and talented actors for a drama series. If you have experience with emotional performances or high-quality cinematography, particularly with night shoots and drone footage, we would love to see your portfolio and hear from you.'`,
    `Only alphabets are allowed in this field.`,
    `Only " -,.'{}[]()" " special characters are allowed.`,
    `Maximum 3 numbers are allowed.`,
  ],
  duration: [`Input the Entire Duration of this proposed project`],
  desiredProfessions: [
    `Select the professions this pitch is intended for or the type of collaboration you're seeking`,
  ],
  taggedIn: [
    `View all the projects or posts where you have been tagged as part of the collaboration.`,
  ],
  teamUp: [
    `Share your pitch or portfolio to collaborate with this talent and work together on something amazing. For teaming up, you can only send your pitches. To hire this talent, use the HireNow button to send your hire proposals.`,
  ],
  hireNow: [
    `Send your hire proposal to this talent for roles or projects you wish to offer. For hiring, use this button. To collaborate and team up, share your pitch using the TeamUp button.`,
  ],
  apply: [
    `Submit your pitch or portfolio as an application for this hire call. Showcase your skills, expertise, and relevant work to be considered for this opportunity.`,
  ],
  accept: ['Accept'],
  reject: ['Reject'],
}

export const ImageFilesType = ['image/png', 'image/jpg', 'image/jpeg']

export const TextFilesType = [
  'text/plain',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]

export const VideoFilesType = [
  'video/mp4',
  'video/ogg',
  'video/webm',
  'video/quicktime',
  'video/x-quicktime',
]

export const AudioFilesType = ['audio/mpeg', 'audio/wav', 'audio/ogg']

export const textFileIcon = {
  txt: <TextIcon />,
  pdf: <PDFIcon />,
  doc: <DocIcon />,
  docx: <DocIcon />,
  png: <PngIcon />,
  ppt: <PptIcon />,
  pptx: <PptIcon />,
}

export const textFile = {
  txt: 'TEXT',
  pdf: 'PDF',
  doc: 'DOC',
  docx: 'DOC',
  png: 'PNG',
  ppt: 'PPT',
  pptx: 'PPT',
}

export const audioFile = {
  'audio/mpeg': 'MP3',
  'audio/wav': 'WAV',
  'audio/ogg': 'OGG',
  mp3: 'MP3',
}

export const notificationTypes = {
  userProfileNotification: [5, 6, 50, 53, 54],
  userVerificationNotification: [53, 54],
  userPostNotification: [1, 4, 10, 14, 33, 34, 36],
  useHirePostNotification: [15, 16, 21, 22, 25, 35],
  userPitchNotification: [2, 3],
  userHireNotification: [17, 18],
  userRequestToViewNotification: [7],
  userHireRequestToViewNotification: [19],
  userAcceptedViewRequestNotification: [8],
  userHireAcceptedViewRequestNotification: [20],
  sendHireToPitchNotification: [27, 28],
  sendPitchToHireNotification: [30, 31],

  userPlaceNotification: [38, 48, 47],
  userPlaceRequestNotification: [39],
  userAcceptedPlaceRequestNotification: [40],
  userRejectedPlaceRequestNotification: [41],

  chatNotification: [9],

  userMarketNotification: [42, 43, 49],
  userMarketRequestNotification: [44],
  userAcceptedMarketRequestNotification: [45],
  userRejectedMarketRequestNotification: [46],
}
